export default () => ({
  channels: [],
  channelInfo: null,
  messages: [],
  membership: null,
  unreadCounts: [],
  unreadCount: 0,
  listener: null,
  pubnub: null,
  pubnubTimestamp: 0,
  firmCounts: [],
  chatBar: []
})



// WEBPACK FOOTER //
// ./src/store/modules/chat/state.js